import type { MyEstimateGroup } from '@massilia/queries'

import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import { CalendarClock } from 'lucide-react'

import { ImportantNotice } from '@/components/ui/important-notice'

interface TariffsLaterNoticeProps {
  group: Pick<MyEstimateGroup, 'tariffsAvailableAt' | 'tariffsLaterMessage'>
}

/**
 * DEVIS-CLIENT-PPT — bandeau « Tarifs indisponibles ».
 *
 * Une demande rangée « Pour plus tard » n'a aucune proposition à montrer : sans
 * ce bandeau, le client verrait un panneau vide et croirait sa demande oubliée.
 * On lui donne donc la seule chose qui compte ici — la date à partir de laquelle
 * les tarifs existeront — en clair et sur sa propre ligne, pas noyée dans une
 * phrase.
 *
 * Bâti sur `ImportantNotice` plutôt qu'à côté : c'est le bandeau d'avertissement
 * du parcours client, il n'y a pas de raison d'en avoir deux.
 */
export function TariffsLaterNotice({ group }: TariffsLaterNoticeProps) {
  if (!group.tariffsLaterMessage) return null

  return (
    <ImportantNotice
      icon={CalendarClock}
      title="Tarifs indisponibles pour le moment"
      variant="warning"
    >
      <p>{group.tariffsLaterMessage}</p>
      {group.tariffsAvailableAt && (
        <p className="mt-1 font-medium text-amber-800">
          Tarifs attendus à partir du{' '}
          {format(new Date(group.tariffsAvailableAt), 'd MMMM yyyy', { locale: fr })}
        </p>
      )}
    </ImportantNotice>
  )
}
